import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { NewbuildingPurchaseGiftGallerySlide } from 'shared/components/NewbuildingPurchaseGiftGallerySlide';
import { NEWBUILDING_PURCHASE_GIFT_SLIDE_BUTTON_TEXT } from 'shared/constants/newbuildingPurchaseGiftPromo';

import { useNewbuildingPurchaseGiftPromo } from './NewbuildingPurchaseGiftPromoContext';

export const NewbuildingPurchaseGiftGallerySlideContainer: React.FC = () => {
  const { openModal, trackGallerySlideShow } = useNewbuildingPurchaseGiftPromo();

  const handleClick = React.useCallback(() => openModal('gallery'), [openModal]);

  return (
    <ActionAfterViewObserver callback={trackGallerySlideShow} triggerOnce wrapper={false}>
      <NewbuildingPurchaseGiftGallerySlide
        buttonText={NEWBUILDING_PURCHASE_GIFT_SLIDE_BUTTON_TEXT}
        onClick={handleClick}
      />
    </ActionAfterViewObserver>
  );
};
